module.exports = __webpack_public_path__ + "img/PGE.baa19a75.jpg";